import { z } from 'zod'
import { oc } from '@orpc/contract'

/**
 * Manual Create resolution of a Match Review: the chart data is confirmed
 * correct and the patient genuinely does not exist in TEFCA, so a new Health
 * Gorilla record is created from the chart demographics verbatim. Only the
 * patient reference crosses the boundary — never FHIR resources and never the
 * retry screen's ephemeral search edits.
 */

const manualCreateInputSchema = z.object({
  patientId: z.string().min(1),
})

export const tefcaManualCreate = oc
  .route({ method: 'POST', path: '/v2/tefca/manual-create' })
  .input(manualCreateInputSchema)
  .output(z.object({ success: z.boolean() }))
